import { useQuery } from "@tanstack/react-query";
import { getInvoiceMetrics, IInvoiceMetrics } from "../actions/getInvoiceMetrics";
// import { EBenefitTypes } from "../../../../utils";

export const useGetInvoiceMetrics = () => {
  // const ent = useAppSelector(selectEntitlement(EBenefitTypes.METRICS_BASIC))

  // console.log("ent", ent);

  const { data, isLoading, isError, error, refetch } = useQuery<IInvoiceMetrics>({
    queryKey: ["invoice-metrics"],
    queryFn: getInvoiceMetrics,
    staleTime: 30000, // Cache for 30 seconds
    refetchOnWindowFocus: true,
    enabled: true,
    retry: false,
  });

  return {
    metrics: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
